import { EntityModel } from '@/interfaces'
import {
  ALL_LINKS_QUERY,
  CREATE_LINK_MUTATION,
  DELETE_LINK_MUTATION,
  FORCE_DELETE_LINK_MUTATION,
  SINGLE_LINK_QUERY,
  UPDATE_LINK_MUTATION,
} from './graphql'
import cmsPageEntity from '@/entities/cmsPage/entity'
import travelEntity from '@/entities/travel/entity'

const linkModel: EntityModel = {
  name: 'link',
  namePlural: 'links',
  uniqueName: 'link',
  uniqueNamePlural: 'links',
  path: 'cms/partials/link',
  baseUrl: '/cms/partials/links',
  translationPrefix: 'entities:link.',
  getDisplayName: (values: any) => {
    return values.url
  },
  gql: {
    getAll: ALL_LINKS_QUERY,
    getSingle: SINGLE_LINK_QUERY,
    create: CREATE_LINK_MUTATION,
    update: UPDATE_LINK_MUTATION,
    delete: DELETE_LINK_MUTATION,
    forceDelete: FORCE_DELETE_LINK_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:link.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    targetBlank: {
      name: 'targetBlank',
      label: 'entities:link.attributes.targetBlank.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    type: {
      name: 'type',
      label: 'entities:link.attributes.type.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'url',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:link.attributes.type.selectOptions.url.label',
          value: 'url',
        },
        {
          label: 'entities:link.attributes.type.selectOptions.page.label',
          value: 'page',
        },
        {
          label: 'entities:link.attributes.type.selectOptions.travel.label',
          value: 'travel',
        },
      ],
      validationType: 'string',
      validations: [],
    },
    url: {
      name: 'url',
      label: 'entities:link.attributes.url.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    page: {
      name: 'page',
      label: 'entities:link.attributes.page.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    travel: {
      name: 'travel',
      label: 'entities:link.attributes.travel.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default linkModel
